<template>
	<dms-edit-layout v-bind="layoutProps">
		<dms-row>
				<dms-card header-localization-key="tsLakSzbNahr">
					<dms-col :md="6" :sm="12" :xs="24">
						<dms-select :select-list="dropdownList.VyrobekvozOzn" :value.sync="VyrobekvozOzn" label-key="VYROBEKVOZ_OZN"
							@update:value="lakDruhClear" />
					</dms-col>
					<dms-col :md="12" :sm="12" :xs="24">
						<lak-druh-select :value.sync="LakdruhOzn" :text.sync="LakdruhOznText" :mutation-name="mutationsMappers.lakDruh" :filter="lakdruhFilter" />
					</dms-col>
					<dms-col :md="6" :sm="12" :xs="24">
						<dms-input-number :value.sync="LakSzbNahr" label-key="LAK_SZB_NAHR" />
					</dms-col>
				</dms-card>
		</dms-row>
	</dms-edit-layout>
</template>

<script>
import { editFactory } from '@/main/pages';
import { LakDruh } from '@/modules/ciselnik/dilenske/lakDruh';

import { editMutations } from './store/types';
import { store } from './store/edit';
import { NAME } from './constants';

export default editFactory(NAME, store).extend({
	components: {
		LakDruhSelect: LakDruh.components.Select,
	},
	computed: {
		mutationsMappers() {
			return {
				lakDruh: `${this.storeUri}/${editMutations.NAHRADNI_SAZBA_LAK_DRUH_SELECT_MAPPER}`,
			};
		},
		lakdruhFilter() {
			return {
				VyrobekvozOzn: this.VyrobekvozOzn,
				VyrazenPrp: false,
			};
		},
	},
	methods: {
		lakDruhClear() {
			this.LakdruhOzn = null;
			this.LakdruhOznText = null;
		},
	},
});
</script>
